















import {Component, Vue} from 'vue-property-decorator';
import CartHeader from '@/components/Cart/CartHeader.vue';
import CartFooter from '@/components/Cart/CartFooter.vue';
import UserStep from '@/components/Checkout/UserStep.vue';
import ShippingStep from '@/components/Checkout/ShippingStep.vue';
import InvoiceStep from '@/components/Checkout/InvoiceStep.vue';
import ReviewStep from '@/components/Checkout/ReviewStep.vue';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';
import user from '@/store/modules/user';
import {Route} from 'vue-router';
import AppBanner from '@/components/UI/AppBanner.vue';
import StripHeader from '@/components/Checkout/StripHeader.vue';
import store from '@/store';
import mse from '@adobe/magento-storefront-events-sdk';
import { Account, Page } from '@adobe/magento-storefront-events-sdk/dist/types/types/schemas';

function guardCurrentStep(currentStep: string): any {
    if (currentStep === 'login' && user.isLoggedin) {
        checkout.lockStep('login');
        return {redirect: '/checkout/shipping'};
    }

    if (currentStep === 'shipping' && cart.isVirtual) {
        return {redirect: '/checkout/invoice'};
    }

    if (['shipping', 'payment'].includes(currentStep) && !store.state.options.guestCheckout && !user.isLoggedin) {
        return {redirect: '/checkout/login'};
    }

    return {};
}

Component.registerHooks(['beforeRouteEnter', 'beforeRouteUpdate']);

@Component({
    components: {
        CartHeader,
        CartFooter,
        UserStep,
        ShippingStep,
        InvoiceStep,
        ReviewStep,
        AppBanner,
        StripHeader,
    },
})
export default class Checkout extends Vue {
    public showCheckoutBackButton: boolean = true;

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get stepName(): string {
        const currentStep = this.$route.params.step;

        switch (currentStep) {
            case 'login':
                return '';
            case 'shipping':
                return 'Shipping';
            case 'invoice':
                return checkout.confirmStep ? 'Check' : 'Payment';
            default:
                return currentStep;
        }
    }

    public toggleCheckoutBackButton(formVisible: string) {
        this.showCheckoutBackButton = !formVisible;
    }

    private mounted() {
        const page: Page = {
            pageType: 'Checkout',
            maxXOffset: 0,
            maxYOffset: 0,
            minXOffset: 0,
            minYOffset: 0,
            ping_interval: 2,
            pings: 1,
        };
        mse.context.setPage(page);
        mse.context.setContext('pageExtended', { action: 'initiate-checkout' });
        const account: Account = {
            firstName: user.customer.firstname,
            lastName: user.customer.lastname,
            emailAddress: user.customer.email,
        };
        mse.context.setAccount(account);
        mse.context.setShopper({ shopperId: user.isLoggedin ? 'logged-in' : 'guest' });
    }

    private beforeRouteEnter(to: Route, from: Route, next: any): void {
        const currentStep = to.params.step;

        checkout.resetSteps(currentStep);

        if (process.env.NODE_ENV === 'production') {
            // guard checkout se non ho i dati del carrello
            if (
                (cart.cart.items.length < 1 ||
                    !checkout.selectedShipment ||
                    checkout.selectedShipment.toString() === '' ||
                    cart.cartHasError) &&
                !cart.isVirtual
            ) {
                next('/');
                return;
            }
        }

        const guardRes = guardCurrentStep(currentStep);
        if (guardRes && guardRes.redirect) {
            next(guardRes.redirect);
            return;
        }
        next();
    }

    private beforeRouteUpdate(to: Route, from: Route, next: any): void {
        const currentStep = to.params.step;
        checkout.resetSteps(currentStep);

        const guardRes = guardCurrentStep(currentStep);
        if (guardRes && guardRes.redirect) {
            next(guardRes.redirect);
            return;
        }
        next();
    }

    private isActive(tabId: string): boolean {
        return tabId === this.$route.params.step;
    }
}
